import app from '../../scripts/app';
import template from './select.jade';

app.directive('scrollMe', () => {
  return {
    scope: {},
    link(scope, element, attrs, ctrl) {
      const elementNode = element[0];

      ctrl.scrollTo = targetElement => {
        const targetElementNode = targetElement[0];
        const targetElementNodeRect = targetElementNode.getBoundingClientRect();
        const elementNodeRect = elementNode.getBoundingClientRect();

        if (elementNodeRect.top > targetElementNodeRect.top) {
          elementNode.scrollTop = targetElementNode.offsetTop;
        }
        else if (elementNodeRect.bottom < targetElementNodeRect.bottom) {
          elementNode.scrollTop = targetElementNode.offsetTop - elementNode.clientHeight + targetElementNode.clientHeight;
        }
      };

      const wheelHandler = function(event) {
        const heightDif = this.offsetHeight - this.clientHeight;
        const maxScrollTop = this.scrollHeight - this.offsetHeight + heightDif;
        const deltaY = (event.originalEvent && event.originalEvent.deltaY) ? event.originalEvent.deltaY : event.deltaY;

        if ((this.scrollTop === maxScrollTop && deltaY > 0) ||
          (this.scrollTop === 0 && deltaY < 0)) {
          event.preventDefault();
        }
      };

      element.bind('wheel', wheelHandler);
    },
    controller() {},
    controllerAs: 'scrollMeCtrl'
  };
});

app.directive('scrollMeTo', () => {
  return {
    scope: {},
    bindToController: {
      scrollMeTo: '='
    },
    require: ['scrollMeTo', '^scrollMe'],
    link(scope, element, attrs, [ctrl, scrollMeCtrl]) {
      if (ctrl.scrollMeTo === true) {
        scrollMeCtrl.scrollTo(element);
      }
    },
    controller() {},
    controllerAs: 'scrollMeToCtrl'
  }
});

app.directive('cianAfSelect', ['$timeout', ($timeout) => {
  return {
    template,
    require: ['cianAfSelect', '?ngModel'],
    scope: {},
    bindToController: {
      items: '=?',
      itemIdKey: '@?',
      itemNameKey: '@?',
      excludedItems: '=?',
      onSelectItem: '&?',
      onCustomItem: '&?',
      onChangeText: '&?',
      cuiInvalid: '=',
      cuiRequired: '=',
      maxlen: '@',
      disabled: '@?',
      allowCustomInput: '@?',
      keepOpen: '@?',
      caption: '@?',
      placeholder: '@?'
    },
    link: (scope, element, attrs, ctrls) => {
      const ctrl = ctrls[0];
      const ngModelCtrl = ctrls[1];

      const elementNode = element[0];
      let isFocused;

      element.attr('tabindex', '0');

      elementNode.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
      });

      document.body.addEventListener('click', event => {
        ctrl.isInputFocused = false;
        ctrl.showList = false;
      });


      elementNode.addEventListener('focus', event => {
        isFocused = true;
      }, true);

      elementNode.addEventListener('blur', event => {
        isFocused = false;
        $timeout(() => {
          if (!isFocused) {
            ctrl.handleBlur();
          }
        }, 0);
      }, true);

      const input = element.find('input');
      input.bind('focus', event => $timeout(() => ctrl.isInputFocused = true));
      input.bind('blur', event => $timeout(() => ctrl.isInputFocused = false));

      if (ngModelCtrl) {
        ctrl.ngModelCtrl = ngModelCtrl;
        ngModelCtrl.$formatters.push(id => ctrl.items && ctrl.items.find(i => i[ctrl.itemIdKey] === id)); // modelValue -> viewValue
        ngModelCtrl.$render = () => ctrl.selectedItem = ctrl.items.find(i => i[ctrl.itemIdKey] === ngModelCtrl.$modelValue); // обновить селект при изм. модели
      }
    },
    controller: ['$scope', '$filter', function ($scope, $filter) {
      this.itemIdKey = this.itemIdKey || 'id';
      this.itemNameKey = this.itemNameKey || 'name';
      this.items = this.items || [];
      this.excludedItems = this.excludedItems || [];
      const getItems = () => {
        let items;
        // Если нет функции onChangeText, сами фильтруем массив
        if (!angular.isFunction(this.onChangeText)) {
          items = $filter('filter')(this.items, {[this.itemNameKey]: this.term}, false);
        } else {
          // Если есть функция onChangeText, она вернет уже нужные варианты
          items = this.items;
        }

        // Убираем уже опции, которые уже выбраны
        items = items.filter(item => this.excludedItems.indexOf(item[this.itemIdKey]) === -1)

        if (this.allowCustomInput && this.term && items.findIndex(item => item[this.itemNameKey].toLowerCase() === this.term.toLowerCase()) === -1) {
          items.unshift({
            [this.itemNameKey]: this.term,
            type: 'text'
          });
        }
        return items.map((item, index) => ({...item, selected: index === 0}));
      };
      this.filteredItems = getItems();

      const setSelectedItem = (direction='right') => {
        const selectedIndex = this.filteredItems.findIndex(item => item.selected === true);
        let nextSelectedIndex = selectedIndex + (direction === 'right' ? 1 : -1);

        if (nextSelectedIndex < 0) {
          nextSelectedIndex = this.filteredItems.length - 1;
        } else if (nextSelectedIndex >= this.filteredItems.length) {
          nextSelectedIndex = 0;
        }

        if (nextSelectedIndex === selectedIndex) {
          return;
        }
        this.setActiveByIndex(nextSelectedIndex);
      };

      this.setActiveByIndex = index => {
        this.filteredItems = this.filteredItems.map((item, itemIndex) => {
          if (item.selected === true && itemIndex !== index) {
            return {
              ...item,
              selected: false
            }
          }
          else if (itemIndex === index) {
            return {
              ...item,
              selected: true
            }
          }

          return item;
        });
      };

      const allowedKeysObj = {
        ESC: 27,
        ENTER: 13,
        ARROW_UP: 38,
        ARROW_DOWN: 40
      };
      const allowedKeysValues = Object.values(allowedKeysObj);

      this.handleKeydown = event => {
        if (!allowedKeysValues.includes(event.keyCode) || this.filteredItems.length === 0) return;
        switch (event.keyCode) {
          case allowedKeysObj.ENTER:
            if (this.showList || this.term !== '') { // если показан список или есть ввод в поле но закрыт список
              this.selectActiveItem();
            }
            break;
          case allowedKeysObj.ARROW_UP:
          case allowedKeysObj.ARROW_DOWN:
            /* если список скрыт - показываем его */
            if (!this.showList) {
              this.showList = true;
            } else {
              setSelectedItem(event.keyCode === allowedKeysObj.ARROW_DOWN ? 'right' : 'left');
            }
            break;
          case allowedKeysObj.ESC:
            this.showList = false;
            this.term = '';
        }
        event.preventDefault();
      };

      const selectActiveItemOnBlur = () => {
        if (this.term) {
          this.selectActiveItem();
        }
      };

      this.handleBlur = () => {
        selectActiveItemOnBlur();
        if (!this.keepOpen) {
          this.showList = false;
        }
      };

      this.selectActiveItem = () => {
        if (this.filteredItems.length > 0) {
          const item = this.filteredItems.find(item => item.selected === true);
          if (item.id) {
            const {selected, type, ...originalItem} = item;
            if (this.onSelectItem) this.onSelectItem({item: originalItem});
          } else if (item[this.itemNameKey]) {
            if (this.onCustomItem) this.onCustomItem({text: item[this.itemNameKey]});
          }
          if (this.ngModelCtrl) {
            this.selectedItem = item;
            this.ngModelCtrl.$setViewValue(item.id);
          }
        }

        if (!this.keepOpen) {
          this.term = '';
          this.showList = false;
        }
      };

      this.showList = false;

      this.toggleList = () => {
        this.showList = this.filteredItems.length > 0 ? !this.showList : false;
      };

      this.handleList = term => {
        this.filteredItems = getItems();
        this.showList = term ? this.filteredItems.length > 0 : false;
      };

      this.isDisabled = () => this.disabled || !this.items || this.items.length === 0;

      $scope.$watch(() => this.term, term => {
        if (angular.isFunction(this.onChangeText)) {
          this.onChangeText({value: term}).then(items => {
            this.items = items;
            this.handleList(term);
          });
        } else {
          this.handleList(term);
        }
      });

      $scope.$watchGroup([() => this.items, () => this.excludedItems], () => {
        this.filteredItems = getItems();
      });

      this.listTracker = item => String(item.id);
    }],
    controllerAs: 'cianAfSelect',
  };
}]);
